import dealDe from './deal/de.json';
import dealEn from './deal/en.json';
import dealIt from './deal/it.json';
import translationDE from './feel/de.json';
import translationEN from './feel/en.json';
import translationIT from './feel/it.json';

const de = { translation: translationDE };
const it = { translation: translationIT };
const en = { translation: translationEN };

export { de, dealDe, dealEn, dealIt, en, it };
